import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import { Color } from '../utils/constants'

interface SectionTagProps {
  title: string
  color?: Color
}

const SectionTag = ({ title, color = Color.BLACK }: SectionTagProps) => {
    const [classes, setClasses] = useState({ text: '', bg: '' })
    const getColorClasses = (clr: Color) => {
        switch (clr) {
        case Color.WHITE:
            return { text: 'text-white', bg: 'bg-white' }
        default:
            return { text: '', bg: '' }
        }
    }
    useEffect(() => {
        setClasses(getColorClasses(color))
    }, [color])
    return (
        <div
            className={twMerge(
                'md:rotate-180 w-max flex items-center gap-x-2 h-max md:vertical-text',
                classes.text,
            )}
        >
            <div className={twMerge('h-px w-5 md:h-5 md:w-px bg-black opacity-40', classes.bg)} />
            <FormattedMessage id={title}>
                {(value) => <span className='section-tag'>{value}</span>}
            </FormattedMessage>
        </div>
    )
}

export default SectionTag
